import { createGlobalStyle } from "styled-components";
import { colors } from "../common/theme";

/* Motiva Sans 只含拉丁字形，中文会走 fallback。
   显式声明中文字体栈，避免在部分系统上退化成宋体。 */
const CJK_STACK = `-apple-system, BlinkMacSystemFont, "PingFang SC",
  "Hiragino Sans GB", "Microsoft YaHei", "Noto Sans CJK SC", sans-serif`;

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', ${CJK_STACK};
    }

    body {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        background: #fff;
        color: ${colors.text};
        overflow-x: hidden;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    input,
    textarea {
        width: 100%;
        padding: 1rem 1.25rem;
        border: 0;
        border-radius: 4px;
        background: ${colors.surface};
        outline: none;
        transition: all 0.3s ease-in-out;

        :focus-within {
            background: none;
            box-shadow: ${colors.primary} 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', ${CJK_STACK};
        color: ${colors.heading};
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }

        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    h1 {
        font-weight: 600;
    }

    /* 中文正文需要比拉丁文更大的行高才舒展 */
    p {
        color: ${colors.text};
        font-size: 16px;
        line-height: 1.8;
    }

    a {
        color: ${colors.primary};
        text-decoration: none;
        outline: none;
        transition: color 0.2s ease-in-out;
    }

    a:hover {
        color: ${colors.accentText};
    }

    *:focus {
        outline: none;
    }

    /* 键盘导航时保留可见焦点环 */
    *:focus-visible {
        outline: 2px solid ${colors.accent};
        outline-offset: 2px;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        padding-top: 1.5rem;
        text-align: left;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
